import compact from 'lodash/compact';
import get from 'lodash/get';

export const PASSWORD_MIN_LENGTH = 8;

export const PASSWORD_POLICY_HINT = `At least ${PASSWORD_MIN_LENGTH} characters. Do not use your name, username or email.`;

const isRecord = (value: unknown): value is Record<string, unknown> => typeof value === 'object' && value !== null;

export const getPasswordPolicyMessages = (error: unknown): string[] => {
    const body: unknown = get(error, 'response.data');
    if (!isRecord(body) || body.code !== 'PASSWORD_POLICY' || !Array.isArray(body.errors)) {
        return [];
    }

    return compact(
        body.errors.map((policyError: unknown) =>
            isRecord(policyError) && typeof policyError.message === 'string' ? policyError.message : null
        )
    );
};
